import 'react-on-rails-pro/registerDefaultRSCProvider/client';
import ReactOnRails from 'react-on-rails-pro/client';
import ProductPageClient from '../../startup/ProductPageClient.client.tsx';

ReactOnRails.register({ProductPageClient});